import React, { createRef, useCallback, useEffect, useRef, useState } from "react";
import _ from "lodash";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { mobileIs, formatDecimal } from "../../../utils/siteUtils";
import { NavLink } from "react-router-dom";
import Videojs from "../../video-js";
import Icon from "../../../elements/icon";
import Loading from "../../../elements/loading";

const WaterFallItem = props => {
  const isMobile = mobileIs();
  const { data, index, playerIndex, oldPlayerIndex, total } = props;
  const videoEl = useRef(null);
  const [playing, setPlaying] = useState(false);
  const { image, video, title, titleMobile, des, desMobile, link } = data.fields;
  const videoOptions =
  video && video.value
    ? {
        sources: [
          {
            src: video.value.src,
            type: video.value.mimeType
          }
        ],
        poster: image.value.src,
        videoTitle: '',
        autoplay: false,
        controls: false ,
        muted: true
      }
    : {};
  const itemLoader = () => {
    props.itemLoader && props.itemLoader(data.id+'item',index);
  }
  const videoPlayPressed = () => {
    document.getElementById('video'+index).classList.add("vjs-has-started")
    props.videoPlayPressed && props.videoPlayPressed(index);
  }
  const videoHover = () => {
    if(videoEl.current && !isMobile){
      if(!isMobile){setPlaying(true)}
      document.getElementById('video'+index).classList.add("vjs-has-started")
      setTimeout(() => {
        videoEl.current.player.play()
      }, 10 );
    }
  }
  const videoPause = () => {
    if(videoEl.current){
      if(playing){
        videoEl.current.player.pause();
        setPlaying(false)
      }else{
        videoEl.current.player.play();
        setPlaying(true)
      }
    }
  }
  const videoOut = () => {
    if(videoEl.current){
      document.getElementById('video'+index).classList.remove("vjs-has-started")
      videoEl.current.player.pause();
      videoEl.current.player.currentTime(0);
      videoEl.current.player.trigger('loadstart');
    }
  }
  
  const like = () => {
    let flag = data.isLike ? true :false
    let _index = total > 6 ? (index + total - 6) : index
    props.like && props.like(data.id,_index,flag);
  }
  useEffect( () => {
    if(index === oldPlayerIndex){
      if(videoEl.current){
        document.getElementById('video'+oldPlayerIndex).classList.remove("vjs-has-started")
        videoEl.current.player.pause();
        videoEl.current.player.currentTime(0);
        videoEl.current.player.trigger('loadstart');
        setPlaying(false)
      }
    }
  },[playerIndex])
  return (
    <>
    <div className="water-fall__list-item-media">
      { !video.value &&
        <div className="water-fall__list-item-img">
          <img width={image.value.width} height={image.value.height} onLoad={itemLoader} src={image.value.src} />
        </div>
      }
      { video && video.value &&
        <>
        <div className="water-fall__list-item-videoImg">
          <img width={image.value.width} height={image.value.height} onLoad={itemLoader} src={image.value.src} />
        </div>
        <div className="water-fall__list-item-video" onMouseOver={videoHover}  onClick={videoPause}  onMouseOut={videoOut} >
          <Videojs ref={videoEl} id={'video'+index} videoPlayPressed={videoPlayPressed} videoLoaded={itemLoader} {...videoOptions} />
        </div>
        </>
      } 
    </div>
    
    {link.value.linktype === "internal" ? (
      <NavLink to={link.value.href} activeClassName="water-fall__list-item-link">
        { ((isMobile && titleMobile) || (!isMobile && title)) &&
          <RichText className="water-fall__list-item-title" tag="div" field={isMobile ? titleMobile : title} />
        }
      </NavLink>
    ) : link.value.linktype === "external" ?
    (
      <a href={link.value.href} target="_blank" className="water-fall__list-item-link">
      { ((isMobile && titleMobile) || (!isMobile && title)) &&
        <RichText className="water-fall__list-item-title" tag="div" field={isMobile ? titleMobile : title} />
      }
      </a>
    ) : (
      ((isMobile && titleMobile) || (!isMobile && title)) &&
        <RichText className="water-fall__list-item-title" tag="div" field={isMobile ? titleMobile : title} />
    )}
    <div className="water-fall__list-item-des">
      {link.value.linktype === "internal" ? (
        <NavLink to={link.value.href} activeClassName="water-fall__list-item-link">
        { ((isMobile && desMobile) || (!isMobile && des)) &&
          <RichText field={isMobile ? desMobile : des} />
        }
        </NavLink>
      ) : link.value.linktype === "external" ?
      (
        <a href={link.value.href} target="_blank" className="water-fall__list-item-link ">
        { ((isMobile && desMobile) || (!isMobile && des)) &&
          <RichText field={isMobile ? desMobile : des} />
        }
        </a>
      ) : (
        ((isMobile && desMobile) || (!isMobile && des)) &&
          <RichText field={isMobile ? desMobile : des} />
      )}
    </div>
    <div className="water-fall__list-item-like" onClick={()=>{like()}}>
      {!data.isLike && <Icon  name="Like"/>}
      {data.isLike && <Icon className="active" name="Liked"/>}
      {/* <Loading /> */}
      { (data.like < 1000 || !data.like) && ( data.like || 0) }
      { data.like > 999 && data.likeOther}
    </div>
    </>
  );
};
export default WaterFallItem;
